import request from '@/utils/request'
const Api = {
    HelpHeader: '/Frontend/Help/header',
    HelpTypeList: '/Frontend/Help/typeList',
    HelpList: '/Frontend/Help/list',
    HelpView: '/Frontend/Help/view'
}

/**
 * 封头配置
 * @returns 
 */
export function getHelpHeader() {
    return request({
        url: Api.HelpHeader,
        method: 'get',
    })
}
/**
 * 帮助类型列表
 * @returns 
 */
export function getHelpTypeList() {
    return request({
        url: Api.HelpTypeList,
        method: 'get',
    })
}
/**
 * 帮助列表
 * @returns 
 */
export function getHelpList(params) {
    return request({
        url: Api.HelpList,
        method: 'get',
        params
    })
}
/**
 * 查看
 * @returns 
 */
 export function getHelpView(params) {
    return request({
        url: Api.HelpView,
        method: 'get',
        params
    })
}



// WEBPACK FOOTER //
// ./src/api/help.js